import Vue from 'vue'

export default {
  getPlans ({ commit }) {
    return Vue.api.get('engine/plans')
      .then((res) => commit('init', { plans: res.data }))
  },
  getInstances ({ commit }) {
    return Vue.api.get('engine/instances')
      .then((res) => commit('init', { instances: res.data }))
  },
  createInstance ({ commit, dispatch }, data) {
    return dispatch('getApiVersion', true).then((api) => api.post('engine/instances', data))
      .then((res) => {
        commit('instance', res.data)
        return res.data
      })
  },
  terminateInstance ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.id).then((api) => api.delete('engine/instances/' + data.id))
      .then((res) => commit('instance', res.data))
  },
  rebootInstance ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.id).then((api) => api.put('engine/instances/' + data.id + '/reboot'))
      .then((res) => commit('instance', res.data))
  },
  increaseVolumeInstance ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.id).then((api) => api.put('engine/instances/' + data.id + '/increase-volume', data))
      .then((res) => commit('instance', res.data))
  },
  resizeInstance ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.id).then((api) => api.put('engine/instances/' + data.id + '/resize', data))
      .then((res) => commit('instance', res.data))
  },
  upgradeInstance ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.id).then((api) => api.put('engine/instances/' + data.id + '/upgrade', data))
      .then((res) => commit('instance', res.data))
  },
  transferInstance ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.id).then((api) => api.put('engine/instances/' + data.id + '/transfer', data))
      .then((res) => commit('instance', res.data))
  },
  updateInstance ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.id).then((api) => api.put('engine/instances/' + data.id, data))
      .then((res) => commit('instance', res.data))
  },
  getInstanceMetrics (context, data) {
    return Vue.api.post('engine/instances/' + data.id + '/metrics', data)
  },
  getInstanceLogs (context, data) {
    return Vue.api.post('engine/instances/' + data.id + '/proxy', data).then((res) => res.data)
  }
}
